import React,{ useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {SetMode} from "../../../../redux/actions/styleActions"

export const useDarkMode = () => {
  const mode = useSelector( (state) => state.style.mode);
  const dispatch = useDispatch();

  const setMode = (mode) => {
    dispatch(SetMode(mode));
  };

  const themeToggler = () => {
    mode === "light" ? setMode("dark") : setMode("light");
  };

  useEffect(() => {
    const localTheme = mode;
    localTheme && dispatch(SetMode(localTheme));
    ;
  }, []);

  return [mode, themeToggler];
};
